//vendor
import ReactPlayer from 'react-player/lazy';

//components
import { Container } from '@/components/Grid/Container';
import { FlexColumnFullCentered } from '@/components/Grid/Flex';
import { BackgroundSection, Title, VideoThumb } from './VideosSection.styles';

export const VideosSection = () => (
  <BackgroundSection>
    <Container>
      <Title>
        What does it mean
        <br /> to be
        <br /> one of us?
      </Title>
      <FlexColumnFullCentered>
        <VideoThumb>
          <ReactPlayer
            className="react-player"
            url="https://www.youtube.com/embed/PW6EYRSjcpA?rel=0"
            controls
            width="100%"
            height="100%"
          />
        </VideoThumb>
      </FlexColumnFullCentered>
      <FlexColumnFullCentered>
        <VideoThumb>
          <ReactPlayer
            className="react-player"
            url="https://www.youtube.com/embed/TxpeJjwSzMM?rel=0"
            controls
            width="100%"
            height="100%"
          />
        </VideoThumb>
      </FlexColumnFullCentered>
    </Container>
  </BackgroundSection>
);
